import { isMainnet } from "@/constants/flags.constant";
import type { HexString } from "@/types/general.types";

//$ ROUTER ADDRESS
const ROUTER_ADDRESS_MAINNET = "0x00000000001fc9d4DdE926c7016409c5eeAa0644";
const ROUTER_ADDRESS_SEPOLIA = "0x0000000000158AB33172239922407A4385cC2f13";
const ROUTER_ADDRESS = isMainnet
  ? ROUTER_ADDRESS_MAINNET
  : ROUTER_ADDRESS_SEPOLIA;

//$ SHIFT GATWAY
const BLESSNET_SHIFT_GATEWAY_TESTNET_ADDRESS =
  "0x000000000000d79998630389a33119953E647646";
const BLESSNET_SHIFT_GATEWAY_MAINNET_ADDRESS =
  "0x0000000000001Deb2E653D32C2e557A96cE2b91D";
const SHIFT_GATEWAY = isMainnet
  ? BLESSNET_SHIFT_GATEWAY_MAINNET_ADDRESS
  : BLESSNET_SHIFT_GATEWAY_TESTNET_ADDRESS;

//$ WORMHOLE ADAPTER 1155
const WORMHOLE_ADAPTER_1155_MAINNET_ADDRESS: HexString =
  (process.env.NEXT_PUBLIC_WORMHOLE_ADAPTER_1155_MAINNET_ADDRESS as
    | HexString
    | undefined) ??
  BLESSNET_SHIFT_GATEWAY_MAINNET_ADDRESS;
const WORMHOLE_ADAPTER_1155_TESTNET_ADDRESS: HexString =
  (process.env.NEXT_PUBLIC_WORMHOLE_ADAPTER_1155_TESTNET_ADDRESS as
    | HexString
    | undefined) ??
  BLESSNET_SHIFT_GATEWAY_TESTNET_ADDRESS;
const WORMHOLE_ADAPTER_1155 = isMainnet
  ? WORMHOLE_ADAPTER_1155_MAINNET_ADDRESS
  : WORMHOLE_ADAPTER_1155_TESTNET_ADDRESS;

//$ TRANSACTION GATEWAY
const txGatewayMainnet: HexString =
  "0x000000000000a5F95dC354b923a50f9b50c2DEca";
const txGatewayTestnet: HexString =
  "0x00000000000063000B7bd997C89951cCe2728E76";
const TRANSACTION_GATEWAY = isMainnet ? txGatewayMainnet : txGatewayTestnet;

//$ DISPENSER
const dispenserMainnet: HexString =
  "0x000000000000a21db7945Fc6A9d9DEfd60358FE6";
const dispenserTestnet: HexString =
  "0x00000000000b81Bb120756126eafC0b731B416c6";
const DISPENSER = isMainnet ? dispenserMainnet : dispenserTestnet;

//$ BLESSNET TOKEN ADDRESS
const BLESS_TOKEN_MAINNET = "0x000000000000cca70b6e0997a94681a3114eddd7";
const BLESS_TOKEN_SEPOLIA = "0x0000000000bbfbab0236d05c06211853f812ec57";
const BLESS_TOKEN = isMainnet ? BLESS_TOKEN_MAINNET : BLESS_TOKEN_SEPOLIA;

export const CONTRACT_ADDRESSES = {
  TRANSACTION_GATEWAY,
  DISPENSER,
  SHIFT_GATEWAY,
  WORMHOLE_ADAPTER_1155,
  BLESS_TOKEN,
  ROUTER_ADDRESS,
} satisfies Record<string, HexString>;
